import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {CustomFormControl} from '../CustomFormControl';

@Component({
  selector: 'app-dynamic-form-label',
  templateUrl: './dynamic-form-label.component.html',
  styleUrls: ['./dynamic-form-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class DynamicFormLabelComponent implements OnInit {

  @Input() control!: CustomFormControl;
  @Input() arrayIndex!: number;
  label: string;

  constructor() {
  }

  ngOnInit(): void {
    this.label = this.control.element.label.replace('{i}', '' + (this.arrayIndex + 1));
  }

}
